import { render, staticRenderFns } from "./log-manage.vue?vue&type=template&id=7ada2dda&scoped=true"
import script from "./log-manage.vue?vue&type=script&lang=js"
export * from "./log-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ada2dda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ada2dda')) {
      api.createRecord('7ada2dda', component.options)
    } else {
      api.reload('7ada2dda', component.options)
    }
    module.hot.accept("./log-manage.vue?vue&type=template&id=7ada2dda&scoped=true", function () {
      api.rerender('7ada2dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/log/log-manage.vue"
export default component.exports